export default __webpack_public_path__ + "static/media/Evolution.eaa1102f.png";